export default "__VITE_ASSET__BT$qKwS___"